// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ifp2","buttons":"Footer_buttons__3TZiu"};